import { render, staticRenderFns } from "./cxSandmeasures.vue?vue&type=template&id=c368d2e0"
import script from "./cxSandmeasures.vue?vue&type=script&lang=js"
export * from "./cxSandmeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cxSandmeasures.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports